export default "__VITE_ASSET__CeN3Idg8__"